import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';
import {Autoplay, Pagination} from 'swiper/modules';
import {gsap} from 'gsap';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

export function initSliders() {
    // --- Hero and slider line animation ---
    function createLineAnimation() {
        const maskPath = document.querySelector("#maskPath");
        if (!maskPath) return null; // alleen als element bestaat

        return gsap.timeline({
            defaults: {ease: "none", duration: 1}
        })
                .fromTo(maskPath,              // gebruik de node ipv "#maskPath"
                        {drawSVG: "100% 100%"},
                        {drawSVG: "0% 100%"}
                )
                .to(maskPath,
                        {drawSVG: "0% 0%"}
                );
    }

    const heroSliderEl = document.querySelector('.hero-slider .swiper-container');
    if (heroSliderEl) {
        const heroSlider = new Swiper(heroSliderEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            parallax: true,
            autoHeight: true,
            effect: 'fade',
            autoplay: {delay: 4000},
            pagination: {
                type: 'bullets',
                el: '.hero-slider_pagination',
                clickable: true,
                modifierClass: 'bg-white',
                currentClass: 'opacity-100',
            }
        });

        // Animatie resetten/starten bij elke slide
        let lineAnimation = createLineAnimation();
        if (lineAnimation) {
            heroSlider.on('slideChangeTransitionStart', () => {
                lineAnimation.kill();
                lineAnimation = createLineAnimation();
                if (lineAnimation) {
                    lineAnimation.duration(heroSlider.params.autoplay.delay / 750);
                    lineAnimation.play();
                }
            });
        }
    }

    // Hero image slider (when featuredImage2 is present)
    const heroImageSwiper = document.querySelector('.hero-swiper');
    if (heroImageSwiper) {
        new Swiper(heroImageSwiper, {
            effect: 'fade',
            autoplay: true,
            fadeEffect: {crossFade: true},
            loop: true,
            speed: 800,
        });
    }

    // Article sliders (images)
    const imagesEl = document.querySelector('.articles__images .swiper-container');
    if (imagesEl) {
        const sliderImages = new Swiper(imagesEl, {
            modules: [Autoplay, Pagination],
            slidesPerView: 1,
            effect: 'fade',
        });

        // Article sliders (thumbs)
        const thumbsEl = document.querySelector('.articles__slides .swiper-container');
        if (thumbsEl) {
            new Swiper(thumbsEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                parallax: true,
                pagination: {
                    type: 'bullets',
                    el: '.articles__pagination',
                    clickable: true,
                    modifierClass: 'bg-white',
                    currentClass: 'opacity-100',
                },
                thumbs: {
                    swiper: sliderImages,
                },
            });
        }
    }
}
